import { render, staticRenderFns } from "./add-sell.vue?vue&type=template&id=5b1b356f"
import script from "./add-sell.vue?vue&type=script&lang=js"
export * from "./add-sell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports